module.exports = __webpack_public_path__ + "img/system50.390f491e.png";